export default __webpack_public_path__ + "5604041ddd3eebb7e1b861fab4b82947.jpg";